


































import {Component} from '@/shared/component';
import {AbstractEditVue} from '@/components/Abstract/AbstractEditVue';

import storeAchat from '@/stores/modules/achat';

import InputAchatFraisList from '@/components/Input/AchatFraisList.vue';
import {Achat} from "@/models";

@Component({
	components: {
		InputAchatFraisList,
	}
})
export default class CrudAchatEditAchatFrais extends AbstractEditVue<Achat> {
	public constructor() {
		super(
			storeAchat,
			'Frais modifié',
			'Frais créé',
		);
	}

}
